import { createMuiTheme } from "@material-ui/core";

export const occasioMaterialTheme = createMuiTheme({
  typography: {
    fontFamily: '"Raleway", "Arial", sans-serif',
  },
  palette: {
    primary: {
      main: "#246f82",
    },
  },
  props: {
    // disable animation
    MuiButtonBase: {
      disableRipple: true,
    },
    MuiInputBase: {
      style: { height: "2.25rem" },
    },
  },
  // disable animation
  transitions: {
    create: () => "none",
  },
});
